"use client";

export default function Error() {
  return (
    <div>We better use our own app to get an idea to solve this problem</div>
  );
}
